import './App.css';

import React, { useEffect, useState } from 'react';

import axios from 'axios';
import csv from 'csvtojson';

function sortNumeric(array) {
  const numer = array.sort((a,b) => {
    return a.id - b.id;
  });

  return numer;
}

function sortAlpha(array) {
  const alpha = array.sort((a,b) => {
    const textA = a.name.toUpperCase();
    const textB = b.name.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
  });
  return alpha;
}

const Exhibitors = (props) => {
  const [ data, setData ] = useState([]);
  const [ sortType, setSortType ] = useState(true);

  useEffect(() => {
    axios
      .get(process.env.PUBLIC_URL + '/data.csv')
      .then((response) => {
        csv()
          .fromString(response.data)
          .then((csvRow) => {
            setData(csvRow);
          });
      });
  }, []);

  const handleClick = (sort) => {
    setSortType(sort);
    if(sort) {
      setData(sortAlpha(data));
    } else {
      setData(sortNumeric(data));
    }
  }

  if(data && data.length > 0) {
    return <>
      <button onClick={() => handleClick(true)} className={sortType ? "button button-black active" : "button button-black"}>Sort by Partner Name</button>
      <button onClick={() => handleClick(false)} className={sortType ? "button button-black" : "button button-black active"}>Sort by Booth Number</button>
      <Listing data={data} sortType={sortType} />
    </>
  } else {
    return <div>Booth information is currently unavailable.</div>
  }
}

const Listing = (props) => {
  const { data } = props;
  return (
    <ul className='sm:columns-2 lg:columns-3 xl:columns-4 space-y-2'>
      {
        data.map((x) => {
          return (
            <li className="flex items-center break-inside-avoid" key={x.id}>
              <span
                className="h-8 w-8 flex shrink-0 justify-center items-center border-2 border-rush mr-2 break-inside-avoid"
                ><span className="sr-only">Booth </span>{x.id}</span>
              <img
                src={process.env.PUBLIC_URL + x.logo}
                alt=""
                className="w-16 h-8 mr-3 shrink-0 object-contain break-inside-avoid"
              />
              <span className="break-inside-avoid">{x.name}</span>
            </li>
          )
      })
    }
    </ul>
  );
}



const Map = (props) => {
  return (
    <figure className="max-w-screen-md mx-auto border mb-4">
      <img src={process.env.PUBLIC_URL + '/images/map.svg'} alt="" className="bg-neutral-200 p-4" />
      <figcaption className="p-4">
        <p>Exhibitors by Booth Number - Purdue Memorial Union</p>
        <p>
          <a href={process.env.PUBLIC_URL + '/images/map.svg'} className="text-blue-600 underline">View full-size image</a>
        </p>
      </figcaption>
    </figure>
  )
}

function App() {
  return (
    <>
      <Map />
      <h2 className="bg-boilermaker-gold sm:text-2xl font-semibold mb-4 p-3 sm:p-4">
        Special Thanks to Our Exhibiting Partners
      </h2>
      <p aria-hidden="true" className="border-b pb-3 mb-8 text-neutral-600">
        <span className="h-8 w-8 inline-flex justify-center items-center border-2 border-rush mr-2">#</span> = Booth number
      </p>
      <Exhibitors />
    </>
  );
}

export default App;
